const XmlCovert = (xml, ) => {
    let convert = require('xml-js');
    const result1 = convert.xml2json(xml, { compact: true, spaces: 4 });
    return result1;
}

export default XmlCovert;